import { Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import BackgroundBlurImage from 'components/Shared/BackgroundBlurImage';
import { IUpsell } from 'interface/upsell';
import { SyntheticEvent, useEffect, useState } from 'react';
import { hjTagging, openUpsell } from 'utils';
import { upsSendJudas } from 'actionCreators/judasLog';
import { IUser } from 'interface/user';
import AceleratorScript from 'components/Shared/AceleratorScript';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import upsellService from 'services/upsell';
import upsellFallbackImg from 'assets/img/nutror-card-upsell.png';
import { CourseTheme } from 'assets/themes/Course';
import useImageFallback from 'hooks/useImageFallback';

const useStyles = makeStyles<CourseTheme>((theme) => ({
  container: {
    '@media(max-width: 1024px)': {
      display: 'none',
    },
    marginTop: theme.spacing(14),
    background: theme.variables.courseTheme.cardBackground,
    borderRadius: 8,
    padding: theme.spacing(3),
    width: '100%',
    maxWidth: '374px',
    height: 'fit-content',
    marginLeft: theme.spacing(4),
  },
  title: {
    color: theme.variables.courseTheme.text,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '100%',
    fontWeight: 700,
  },
  imageContainer: {
    display: 'flex',
    position: 'relative',
    margin: 'auto',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    borderRadius: 8,
    overflow: 'hidden',
    width: '100%',
    maxWidth: 360,
    height: 247,
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& button': {
      textTransform: 'none',
      fontWeight: 600,
      fontSize: 14,
      color: theme.palette.common.white,
      marginLeft: theme.spacing(2),
    },
  },
  description: {
    color: theme.variables.courseTheme.text,
    padding: theme.spacing(3, 0),
    whiteSpace: 'pre-line',
    wordBreak: 'break-word',
  },
}));

interface IProps {
  user: IUser;
}

const Upsell = (props: Partial<IProps>) => {
  const [upsell, setUpsell] = useState<IUpsell>(null);
  const classes = useStyles();
  const params = useParams<{ courseHash: string }>();
  const imageProps = useImageFallback(upsell?.showcase_image ?? upsell?.small_image, upsellFallbackImg);

  const openOffer = (event: SyntheticEvent) => {
    if (upsell === null || Object.keys(upsell).length === 0) return;
    hjTagging('CURSO-CLICOU-UPSELL');
    upsSendJudas({
      action: 'click',
      id: upsell.id,
      hash_checkout: upsell.content,
      viewd: 'page_course',
      producer_id: upsell.producer_id,
      user_id: props.user.id,
    });

    openUpsell(event, upsell, 'CURSO', props.user);
  };

  useEffect(() => {
    upsellService.getUpsell(params.courseHash).then(setUpsell);
  }, [params.courseHash]);

  useEffect(() => {
    if (!upsell || Object.keys(upsell).length === 0) return;
    hjTagging('CURSO-EXIBIU-UPSELL');
    upsSendJudas({
      action: 'view',
      id: upsell.id,
      hash_checkout: upsell.content,
      viewd: 'page_course',
      producer_id: upsell.producer_id,
      user_id: props.user.id,
    });
  }, [props.user.id, upsell]);

  if (!upsell || Object.keys(upsell).length === 0) {
    return null;
  }

  return (
    <div className={classes.container}>
      <AceleratorScript />
      <Typography variant='h4' className={classes.title}>
        {upsell.title}
      </Typography>
      <div className={classes.imageContainer}>
        <BackgroundBlurImage {...imageProps} alt={upsell.title} />
      </div>
      <Typography className={classes.description}>{upsell.description}</Typography>
      <div className={classes.actions}>
        <Button variant='contained' color='primary' onClick={openOffer}>
          {upsell.label_text || 'Saiba Mais'}
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.user,
});

export default connect(mapStateToProps)(Upsell);
